import { useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@store/store'
import { captureDeeplink } from '@/store/slices/deeplink/action'
import { selectDeeplinkFlows } from '@/store/slices/deeplink/selectors'
import { DEEPLINK_PARAM_KEYS, DEEPLINK_FLOWS } from './registry'

const DeeplinkParser = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const location = useLocation()
  const existingFlows = useSelector(selectDeeplinkFlows)
  /** Avoid duplicate capture for the same `location.search` in one SPA session (e.g. StrictMode double effect). */
  const lastCapturedSearchRef = useRef<string | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const po = params.get('po')
    if (!po) {
      lastCapturedSearchRef.current = null
      return
    }
    if (!DEEPLINK_FLOWS[po] || existingFlows[po]) return

    const searchFingerprint = location.search
    if (lastCapturedSearchRef.current === searchFingerprint) return

    lastCapturedSearchRef.current = searchFingerprint

    const deeplinkParams: Record<string, string> = {}
    DEEPLINK_PARAM_KEYS.forEach(key => {
      const val = params.get(key)
      if (val) {
        deeplinkParams[key] = val
        params.delete(key)
      }
    })

    dispatch(captureDeeplink(deeplinkParams))
    history.replace({ pathname: location.pathname, search: params.toString() })
  }, [location.pathname, location.search, existingFlows, dispatch, history])

  return null
}

export default DeeplinkParser
